@let minRows = rows() === 'auto' ? 1 : rows();
@let maxRows = rows() === 'auto' ? 50 : rows();
<mat-form-field
  class="lib-input coin-form-field-outline coin-form-field-outline--{{ matFormFieldClass() }} no-margin"
  matTooltipClass="error-tooltip"
  appearance="outline"
  floatLabel="always"
  [matTooltip]="errorTooltip()"
  [matTooltipDisabled]="!touched()">
  @if (label()) {
    <mat-label>
      {{ label() }}
      @if (required()) {
        *
      }
    </mat-label>
  }
  <textarea
    matInput
    autocomplete="off"
    [cdkTextareaAutosize]="!sizesToContent"
    [cdkAutosizeMinRows]="minRows"
    [cdkAutosizeMaxRows]="maxRows"
    [class.sizes-to-content]="sizesToContent"
    [style.min-height.lh]="sizesToContent ? minRows : null"
    [style.max-height.lh]="sizesToContent ? maxRows : null"
    [placeholder]="placeholder()"
    [attr.readonly]="disabled() ? true : null"
    [disabled]="disabled()"
    [ngModel]="viewValue()"
    (ngModelChange)="updateValue($event)"
    (blur)="markAsTouched()"></textarea>
  @if (icon()) {
    <mat-icon>{{ icon() }}</mat-icon>
  }
</mat-form-field>
